import * as React from 'react';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';
import dayjs from 'dayjs';
import CollapsibleArea from '../../common/CollapsibleArea';
import ImagesDisplay from '../../common/ImagesDisplay';
import Loader from '../../common/Loader';
import GoogleMapsModal from '../../common/GoogleMapsModal';
import ClipboardIcon from '../../common/ClipboardIcon';
import ReactTooltip from 'react-tooltip';
import Axios from 'axios';
import FileDownload from 'js-file-download';
import Dialog from '../../../utilities/Dialog';

export interface IProps {
    handleClose: any;
    details: any;
    toggleVertical: any;
    isVertical: boolean;
    userId: any;
}

const Details: React.FC<IProps> = (props: IProps) => {
    //r-18-lint-dj
    //eslint-disable-next-line
    const { handleClose, toggleVertical, isVertical, userId } = props;
    const [loading, setLoading] = React.useState(false);
    const [details, setDetails] = React.useState({} as any);
    const [isCarousel, setIsCarousel] = React.useState(false);
    const [googleMapsOpen, setGoogleMapsOpen] = React.useState(false);
    const [textPreviewOpen, setTextPreviewOpen] = React.useState(false);
    const [selectedImages, setSelectedImages] = React.useState([] as any);

    const changeDisplay = (e: React.SyntheticEvent, displayCarousel: boolean) => {
        e.preventDefault();
        e.stopPropagation();
        setIsCarousel(displayCarousel);
    }

    const getTicketDetails = () => {
        //console.log("Props", props);
        setLoading(true);
        axios.get(process.env.REACT_APP_API_URL + `/api/TicketQuery/GetTicketDetail?ticketId=${props.details.TicketID}`, AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log(res);
                setDetails(res.data);
            })
            .catch((err: any) => {
                //console.log(err);
            })
            .finally(() => { setLoading(false); })
    }

    const toggleGoogleMaps = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setGoogleMapsOpen(!googleMapsOpen);
    }

    const downloadImages = async (e: React.MouseEvent) => {
        e.preventDefault();
        const prompt: any = new Dialog({
            message: "Type in a name for the file",
            trueText: "Confirm",
            type: "prompt"
        });
        let answer: any = await prompt.show();
        if (answer) {
            const rb: any = {
                userId: props.userId,
                images: selectedImages.length > 0 ? selectedImages : details.PictureCollection.map((p: any) => p.ImageFullUrl)
            };
            Axios({
                url: `${process.env.REACT_APP_API_URL}/api/TicketQuery/CompressPictures`,
                method: 'POST',
                responseType: 'blob', // Important
                // body: rb
                data: rb,
                headers: {
                    authorization: AxiosConfig.configValue("min").headers.authorization
                }
            }).then((response: any) => {
                FileDownload(response.data, `${answer}.zip`);
            });
        }
    }

    const toggleTextPreview = (e: React.SyntheticEvent) => { setTextPreviewOpen(!textPreviewOpen); }

    React.useEffect(() => {
        //console.log("Setting Events");
        let arrowEvents: any = document.addEventListener("keyup", (e: KeyboardEvent) => {
            const { key } = e;
            //console.log("Arrow Events!");
            if (key === "Escape") {
                setTextPreviewOpen(false);
            }
        })
        return () => {
            document.removeEventListener("keydown", arrowEvents);
        }
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [])

    //r-18-lint-dj
    //eslint-disable-next-line
    React.useEffect(() => { getTicketDetails(); }, [props.details]);

    return (
        <>
            <div className="col-9 col-md-12 d-flex flex-column h-100 overflow-auto bg-white">
                {
                    loading
                        ? <Loader title="Loading Ticket Details..." />
                        :
                        <>
                            <div className="d-flex flex-column ticket-search-detail-section" style={{ marginBottom: 20, backgroundColor: "#f3f3f3" }}>
                                <div className="w-50 ml-auto d-flex justify-content-between align-items-center">
                                    <span className="text-secondary">Ticket Id: {details.TicketID}</span>
                                    <div className="d-flex flex-row align-items-center ml-auto" style={{ marginBottom: 10, marginRight: -10, paddingRight: 10 }}>
                                        <button onClick={toggleVertical} className={`action-text material-icons ${isVertical ? "rotate-90" : ""}`}>swap_horiz</button>
                                        <button className="action-text-danger material-icons" onClick={props.handleClose}>close</button>
                                    </div>
                                </div>
                                <div style={{ paddingLeft: 10 }} className="d-flex flex-column flex-md-row double-panel-background">
                                    <div className="col-12 col-md-6 p-0 m-0 d-flex flex-column">
                                        <h4 className="overflow-ellipsis text-nowrap">{details.TicketNumber}</h4>
                                        <div className="d-flex align-items-center double-panel-address mb-2">
                                            <span className="font-weight-bold">Version: </span>
                                            <span className="overflow-ellipsis text-nowrap ml-1">{details.TicketRevision}</span>
                                        </div>
                                        <div className="d-flex align-items-center double-panel-address mb-2">
                                            <span className="font-weight-bold">Type: </span>
                                            <span className="overflow-ellipsis text-nowrap ml-1">{details.TicketType}</span>
                                            {/* TicketType */}
                                        </div>
                                        <div onClick={toggleGoogleMaps} className="d-flex flex-column justify-content-start mb-1 action-text">
                                            <span title={details.Address} className="overflow-ellipsis double-panel-address">{details.Address}</span>
                                            <span className="text-nowrap double-panel-address">{details.City}, {details.State}</span>
                                        </div>
                                        <GoogleMapsModal onClose={() => setGoogleMapsOpen(false)} open={googleMapsOpen} lat={details.GeoLat} lon={details.GeoLong} />
                                        <div className="d-flex flex-row justify-content-between align-items-center">
                                            <ReactTooltip id="view-address-toggle" effect="solid" type="dark" place="right">
                                                <span>Click to view location.</span>
                                            </ReactTooltip>
                                            <span onClick={e => { e.preventDefault(); setGoogleMapsOpen(true); }} data-tip data-for="view-address-toggle" style={{ fontSize: "1.0rem" }} className="text-secondary action-text">
                                                {Number(details.GeoLat).toFixed(6)}, {Number(details.GeoLong).toFixed(6)}
                                            </span>
                                            <ClipboardIcon styles={{ zIndex: 1, width: 20, display: "flex", alignItems: "center", marginLeft: 20 }} text={`${details.GeoLat}, ${details.GeoLong}`} show />
                                        </div>
                                        <div className="double-panel-divider" />
                                        <div className="d-flex flex-row" style={{ marginTop: 10, marginBottom: 20 }}>
                                            <span className="font-weight-bold text-secondary">DATE: </span>
                                            <span style={{ marginLeft: 5 }}>{dayjs(details.ImportDatets).format("MM/DD/YYYY")}</span>
                                        </div>
                                    </div>
                                    <div className="bg-white col-12 col-md-6 m-0 d-flex justify-content-center flex-column" style={{ paddingLeft: 20 }}>
                                        <div className="d-flex flex-column justify-content-start" style={{ marginBottom: 20 }}>
                                            <span className="font-weight-bold w-20">Excavator: </span>
                                            <span className="overflow-ellipsis text-nowrap">{details.Excavator}</span>
                                        </div>
                                        <div className="d-flex flex-column justify-content-start">
                                            <span className="font-weight-bold">ELM Area</span>
                                            <span className="overflow-ellipsis text-nowrap">{props.details.ELMArea}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white" style={{ height: 20 }} />
                            </div>
                            <CollapsibleArea Toggle={(p: any) => <div {...p} className="d-flex align-items-center flex-row cursor-on-hover pb-2 ticket-search-header" style={{ marginBottom: 20 }}>
                                {/* History Section */}
                                <i style={{ fontSize: "1.5rem", marginRight: 5 }} className="material-icons text-success">history</i>
                                <h4 className="m-0">History</h4>
                                <i className="material-icons text-secondary ml-auto" style={{ fontSize: "1.5rem" }}>{p.open ? "expand_less" : "expand_more"}</i>
                            </div>} startOpen>
                                <div className="ticket-search-detail-section">
                                    <table style={{ maxHeight: 500, overflowY: "scroll" }} className="table table-hover flush-table table-flush">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {details.ActionCollection ? details.ActionCollection.sort((a: any, b: any) => b.ActionDatets - a.ActionDatets).map((action: any, index: number) =>
                                                <tr key={index}>
                                                    <td>{dayjs(action.ActionDatets).format("MM/DD/YYYY hh:mmA")}</td>
                                                    <td>{action.Action}</td>
                                                </tr>
                                            ) : null}
                                        </tbody>
                                    </table>
                                </div>
                            </CollapsibleArea>
                            <CollapsibleArea startOpen Toggle={(p: any) => <div {...p} className="d-flex align-items-center flex-row cursor-on-hover pb-2 ticket-search-header" style={{ marginBottom: 20 }}>
                                <i style={{ fontSize: "1.5rem", marginRight: 5 }} className="material-icons text-success">text_snippet</i>
                                <h4 className="m-0">Ticket Text</h4>
                                <i className="material-icons text-secondary ml-auto" style={{ fontSize: "1.5rem" }}>{p.open ? "expand_less" : "expand_more"}</i>
                            </div>}>
                                <textarea onClick={toggleTextPreview} style={{ minHeight: 500, maxHeight: 800 }} readOnly className="w-100 h-100 cursor-on-hover border-0 ticket-search-detail-section" value={details.TicketFullText}></textarea>
                            </CollapsibleArea>
                            <CollapsibleArea startOpen Toggle={(p: any) => <div {...p} className="d-flex justify-content-between align-items-center cursor-on-hover pb-2 ticket-search-header" style={{ marginBottom: 20 }}>
                                <div className="d-flex align-items-center flex-row">
                                    <i style={{ fontSize: "1.5rem", marginRight: 5 }} className="material-icons text-success">image</i>
                                    <h4 className="m-0">Pictures ({details.PictureCollection?.length})</h4>
                                </div>
                                <div>
                                    <i onClick={downloadImages} className="material-icons action-icon cursor-on-hover z-1" title="Download All Picutres.">download</i>
                                    <i
                                        onClick={e => changeDisplay(e, true)}
                                        className={`material-icons action-icon cursor-on-hover z-1 ${isCarousel && "text-primary"}`}
                                    >view_column</i>
                                    <i
                                        style={{ marginRight: 10 }}
                                        onClick={e => changeDisplay(e, false)}
                                        className={`material-icons action-icon cursor-on-hover z-1 ${!isCarousel && "text-primary"}`}
                                    >view_module</i>
                                    <i className="material-icons text-secondary ml-auto" style={{ fontSize: "1.5rem" }}>{p.open ? "expand_less" : "expand_more"}</i>
                                </div>
                            </div>}>
                                <div className="ticket-search-detail-section">
                                    <ImagesDisplay
                                        images={details.PictureCollection?.map((pic: any) => ({ src: pic.ImageFullUrl, alt: pic.Comments || "" })) || []}
                                        isCarousel={isCarousel}
                                        allowSelect
                                        handleSelect={(newSelectedImages: any) => setSelectedImages(newSelectedImages)}
                                    />
                                </div>
                            </CollapsibleArea>
                        </>
                }
            </div>
            {textPreviewOpen && (
                <div onClick={toggleTextPreview} className="text-preview-modal">
                    <div onClick={e => { e.stopPropagation() }} className="w-60 d-flex flex-column p-2 bg-light">
                        <i onClick={toggleTextPreview} className="material-icons cursor-on-hover ml-auto action-text">close</i>
                        <textarea
                            name="split-description"
                            id="split-description"
                            defaultValue={details.TicketFullText}
                            onClick={e => { e.stopPropagation() }}
                            className="w-100 h-100 border-0 overflow-scroll"
                            style={{ minHeight: "80vh", fontFamily: "monospace, serif" }}
                        />
                    </div>
                </div>
            )}
        </>
    );
}

export default Details;